export default {
	topElementsHeight: (state) =>
		state.domElements.topAdHeight + state.domElements.headerHeight,
};
